export default __webpack_public_path__ + "static/media/exploded-view_labels.75666f67.png";